// 支付订单相关字典

export const payOrderDict = {
  // 订单状态
  payStatus: {
    '-1': { color: '#8E8E93', label: '初始化', show: true },
    '0': { color: '#1890ff', label: '处理中', show: true },
    '1': { color: '#52c41a', label: '成功', show: true },
    '2': { color: '#ff4d4f', label: '失败', show: true },
    default: { color: '#d9d9d9', label: '未知', show: false },
  },

  // 手续费状态
  feeStatus: {
    '0': { color: '#8E8E93', label: '无手续费', show: true },
    '1': { color: '#1890ff', label: '处理中', show: true },
    '2': { color: '#ff4d4f', label: '失败', show: true },
    '3': { color: '#52c41a', label: '成功', show: true },
    default: { color: '#d9d9d9', label: '未知', show: false },
  },

  // 支付类型
  payType: {
    '300310': { color: '#1890ff', label: '通用协议支付', show: true },
    '300310-1': { color: '#722ed1', label: '免密协议支付', show: true },
    '300310-2': { color: '#fa8c16', label: '通用协议支付2', show: true },
    '300311': { color: '#13c2c2', label: '协议代扣支付', show: true },
    default: { color: '#d9d9d9', label: '未知', show: false },
  },
};

/**
 * 获取字典项
 * @param {string} type - 字典类型 (payStatus|feeStatus|payType)
 * @param {string|number} key - 字典key
 * @returns {object} { color, label }
 */
export function getDictItem(type, key) {
  const dict = payOrderDict[type];
  if (!dict) return { color: '#d9d9d9', label: '未知' };
  // 优先尝试字符串key，再尝试数字key
  return dict[String(key)] || dict[Number(key)] || dict.default || { color: '#d9d9d9', label: String(key) };
}

/**
 * 获取状态颜色
 */
export function getStatusColor(status) {
  return getDictItem('payStatus', status).color;
}

/**
 * 获取状态文本
 */
export function getStatusText(status) {
  return getDictItem('payStatus', status).label;
}

/**
 * 获取手续费状态颜色
 */
export function getFeeStatusColor(status) {
  return getDictItem('feeStatus', status).color;
}

/**
 * 获取手续费状态文本
 */
export function getFeeStatusText(status) {
  return getDictItem('feeStatus', status).label;
}

/**
 * 获取支付类型颜色
 */
export function getPayTypeColor(payType) {
  return getDictItem('payType', payType).color;
}

/**
 * 获取支付类型文本
 */
export function getPayTypeText(payType) {
  return getDictItem('payType', payType).label;
}

/**
 * 获取选项列表（排除default）
 */
export function getOptions(type) {
  const dict = payOrderDict[type];
  if (!dict) return [];
  return Object.keys(dict)
    .filter(key => key !== 'default')
    .reduce((acc, key) => {
      acc[key] = dict[key];
      return acc;
    }, {});
}

/**
 * 获取支付状态选项
 */
export function getPayStatusOptions() {
  return getOptions('payStatus');
}

/**
 * 获取手续费状态选项
 */
export function getFeeStatusOptions() {
  return getOptions('feeStatus');
}

/**
 * 获取支付类型选项
 */
export function getPayTypeOptions() {
  return getOptions('payType');
}
